<template>
  <div :class="notIE ? 'notIE' : 'isIE'">
    <slot />
  </div>
</template>

<script>
/**
 * This component is meant to wrap a component tree to provide it with the material
 * icon font
 */
export default {
  name: 'IconFontWrapper',
  computed: {
    notIE() {
      const UA = window.navigator.userAgent.toLowerCase();
      const isIE = UA && /msie|trident/.test(UA);
      return !isIE;
    },
  },
};
</script>

<style>
/* This is the material icons CSS fallback */
.material-icons {
  font-family: 'Material Icons';
  direction: ltr;
  font-feature-settings: 'liga';
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}

.notIE .material-icons {
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
}
</style>
